import { render, staticRenderFns } from "./address.vue?vue&type=template&id=fdf6ff52&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"
import style0 from "./address.vue?vue&type=style&index=0&id=fdf6ff52&prod&lang=scss&scoped=true"
import style1 from "./address.vue?vue&type=style&index=1&id=fdf6ff52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6ff52",
  null
  
)

export default component.exports